import {
  createSlice,
} from "@reduxjs/toolkit";
import { REDUX_CONSTANTS } from "../action-constants";
import { STRING_CONSTANTS } from "constants/common";
import {
  getStorageItem,
} from "config/network";

const { STORED_KEYS } = STRING_CONSTANTS;
export const initialauthState = {
  loadingStatus: "not loaded",
  error: null,
  isLoading: false,
  userDetails: getStorageItem(STORED_KEYS.USER_DETAILS),
};

export const authSlice = createSlice({
  name: REDUX_CONSTANTS.AUTH.FEATURE_KEY,
  initialState: initialauthState,
  reducers: {},
});

export const authReducer = authSlice.reducer;

export const getAuthState = (rootState) =>
  rootState[REDUX_CONSTANTS.AUTH.FEATURE_KEY];
